<div class="space-y-6 p-5">

  <!-- Header -->
  <div>
    <h2 class="text-sm font-semibold text-slate-900">Monitoring Usage</h2>
    <p class="mt-0.5 text-xs text-slate-500">Service monitoring quota across all users. Sorted by usage percentage.</p>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex items-center gap-2 text-sm text-slate-400">
    <lucide-icon name="loader" [size]="14" class="animate-spin" [strokeWidth]="2"></lucide-icon>
    Loading…
  </div>

  <!-- Error -->
  <div *ngIf="error" class="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
    <lucide-icon name="triangle-alert" [size]="14" [strokeWidth]="2"></lucide-icon>
    {{ error }}
  </div>

  <!-- Empty -->
  <div *ngIf="!loading && !error && rows.length === 0"
    class="rounded-xl border border-slate-200 bg-white py-12 text-center text-sm text-slate-400">
    No monitoring activity yet.
  </div>

  <!-- Table -->
  <div *ngIf="!loading && rows.length > 0" class="overflow-hidden rounded-xl border border-slate-200 bg-white">
    <table class="w-full text-left text-sm">
      <thead>
        <tr class="border-b border-slate-100 bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-400">
          <th class="px-4 py-3">User</th>
          <th class="px-4 py-3">Tier</th>
          <th class="px-4 py-3">Usage</th>
          <th class="px-4 py-3 text-right">Count / Limit</th>
          <th class="w-8 px-4 py-3"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of rows">
          <!-- Main row -->
          <tr
            class="border-b border-slate-100 transition-colors hover:bg-slate-50 cursor-pointer"
            [class.bg-slate-50]="expandedUserId === row.userId"
            (click)="toggleExpand(row.userId)"
          >
            <td class="px-4 py-3">
              <p class="font-medium text-slate-800">{{ row.email }}</p>
              <p class="font-mono text-[10px] text-slate-400">{{ row.userId }}</p>
            </td>
            <td class="px-4 py-3">
              <span class="rounded-full px-2 py-0.5 text-[11px] font-semibold" [class]="tierBadgeClass(row.tier)">
                {{ row.tier }}
              </span>
            </td>
            <td class="px-4 py-3">
              <div class="h-1.5 w-32 overflow-hidden rounded-full bg-slate-100">
                <div
                  class="h-full rounded-full transition-all"
                  [class]="quotaBarClass(row)"
                  [style.width.%]="row.percentUsed"
                ></div>
              </div>
              <p class="mt-1 text-[11px] text-slate-400">{{ row.percentUsed }}% used</p>
            </td>
            <td class="px-4 py-3 text-right">
              <span [class.text-red-600]="row.percentUsed >= 100"
                    [class.text-amber-600]="row.percentUsed >= 80 && row.percentUsed < 100"
                    [class.text-slate-700]="row.percentUsed < 80"
                    class="font-semibold">
                {{ row.monitoredCount }}
              </span>
              <span class="text-slate-400"> / {{ row.limit }}</span>
            </td>
            <td class="px-4 py-3 text-slate-400">
              <lucide-icon [name]="expandedUserId === row.userId ? 'chevron-right' : 'chevron-right'"
                [size]="13" [strokeWidth]="2"
                class="transition-transform"
                [class.rotate-90]="expandedUserId === row.userId"
              ></lucide-icon>
            </td>
          </tr>

          <!-- Expanded service entries -->
          <tr *ngIf="expandedUserId === row.userId" class="bg-slate-50">
            <td colspan="5" class="px-6 pb-4 pt-2">
              <div *ngIf="userServicesLoading[row.userId]" class="flex items-center gap-2 py-2 text-xs text-slate-400">
                <lucide-icon name="loader" [size]="12" class="animate-spin" [strokeWidth]="2"></lucide-icon>
                Loading services…
              </div>
              <div *ngIf="!userServicesLoading[row.userId]">
                <p *ngIf="!userServices[row.userId]?.length" class="py-2 text-xs text-slate-400">
                  No service entries found.
                </p>
                <div *ngIf="userServices[row.userId]?.length" class="flex flex-wrap gap-2 py-1">
                  <div
                    *ngFor="let svc of userServices[row.userId]"
                    class="flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[11px]"
                    [class]="serviceTypeBadge(svc.serviceType)"
                    [class.opacity-40]="!svc.isMonitored"
                  >
                    <span class="font-semibold">{{ svc.serviceType }}</span>
                    <span class="text-slate-500">·</span>
                    <span class="font-mono">{{ svc.resourceId }}</span>
                    <span *ngIf="svc.isMonitored"
                      class="ml-1 h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

</div>
